import React from "react";
import { Modal } from "../../components";
import { LocalFormSectionTemplate } from "components/MainSectionTemplate/LocalFormSectionTemplate";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import { PhosphorGearAnchor } from "components/Atoms/PhosphorIconAnchor";
import NoAdvancingTemplatesMessageBox from "components/MessageBox/NoAdvancingTemplatesMessageBox";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  templates: server.dto.AdvancingTemplate[]
  onTemplateSelected: (template: server.dto.AdvancingTemplate) => void
  onClose: () => void
}

const ChooseAdvancingTemplate = (props: Props) => {
  const [selectedTemplateId, setSelectedTemplateId] = React.useState(props.templates[0]?.advancingTemplateId);

  const hasTemplates = props.templates.length > 0;

  const renderTemplates = () => <div className="flex gap-small main-section-template-fields-padding">
    <div className="grow1">
      <RadioGroup<number>
        orientation="vertical"
        options={props.templates.map(t => ({ label: t.name, value: t.advancingTemplateId }))}
        value={selectedTemplateId}
        onChange={setSelectedTemplateId}
      />
    </div>
    {site.permissions.canConfigureTemplates && <div>
      <PhosphorGearAnchor
        href={routes.advancingTemplate_List().absolute}
        layout="in-square"
        backgroundColor="light"
        padding="large"
      />
    </div>}
  </div>;

  return <Modal
    isOpen
    handleClose={props.onClose}
    title="Start new advancing session"
    width="small"
  >
    <LocalFormSectionTemplate
      saveButtonLabel={RESX.GeneralLabels.NextResx}
      saveButtonDisabled={!hasTemplates}
      onSuccess={() => props.onTemplateSelected(props.templates.find(t => t.advancingTemplateId === selectedTemplateId))}
      sections={[hasTemplates
        ? {
          key: "template",
          type: "regular",
          title: RESX.Advancing.AdvancingTemplate,
          hideTitle: true,
          fields: [{
            key: "template",
            label: RESX.Advancing.AdvancingTemplate,
            renderEditNew: renderTemplates
          }]
        }
        : {
          key: "noTemplates",
          type: "custom",
          render: () => <NoAdvancingTemplatesMessageBox key="noTemplates" />
        }]}
    />
  </Modal>;
};

export default ChooseAdvancingTemplate;
